<template>
  <v-btn
    @click="setSimilarItemsOrderBy(orderBy)"
    :color="color"
    :dark="selected && !loadingSimilarItems"
    :disabled="loadingSimilarItems"
    :loading="loadingSimilarItems && selected"
  >
    <span>{{ orderBy }}</span>
    <v-fade-transition>
      <v-icon v-if="selected" class="ml-2">sort</v-icon>
    </v-fade-transition>
  </v-btn>
</template>

<script>
import { mapMutations, mapState } from "vuex";

export default {
  props: {
    orderBy: {
      type: String,
      required: true
    }
  },
  computed: {
    ...mapState("matching", ["similarItemsOrderBy", "loadingSimilarItems"]),
    color() {
      return this.selected ? "purple darken-1" : "";
    },
    selected() {
      return this.orderBy == this.similarItemsOrderBy;
    }
  },
  methods: {
    ...mapMutations("matching", ["setSimilarItemsOrderBy"])
  }
};
</script>
